import { BreakpointObserver } from '@angular/cdk/layout';
import {
    Component,
    DestroyRef,
    inject,
    Input,
    OnInit,
    signal,
    WritableSignal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { paginate } from '@netwealth/nw-utils';
import { map, Observable, tap } from 'rxjs';
import { OutlineButtonComponent } from '../../../../../button/button.component';
import { IconComponent } from '../../../../../icon/icon.component';
import { PillComponent } from '../../../../../pill/pill.component';
import { ArticlesBlockComponent } from '../../articles-block.component';
import { Article } from '../../models/articles.model';

@Component({
    selector: 'nw-articles-carousel-block',
    imports: [
        OutlineButtonComponent,
        IconComponent,
        PillComponent,
        ArticlesBlockComponent
    ],
    templateUrl: './articles-carousel-block.component.html',
    styleUrl: './articles-carousel-block.component.scss'
})
export class ArticlesCarouselBlock implements OnInit {
    @Input() title?: string;
    @Input() articles!: Article[];

    public selectedIndex$$: WritableSignal<number> = signal(0);
    public pages$$: WritableSignal<Article[][]> = signal([]);

    private breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
    private destroyRef = inject(DestroyRef);
    private gridSize$: Observable<1 | 2 | 4> = this.breakpointObserver
        .observe(['(max-width: 767px)', '(min-width: 768px)', '(min-width: 1200px)'])
        .pipe(
            map((state) => {
                if (state.breakpoints['(min-width: 1200px)']) {
                    return 4;
                } else if (state.breakpoints['(min-width: 768px)']) {
                    return 2;
                } else if (state.breakpoints['(max-width: 767px)']) {
                    return 1;
                } else {
                    return 1;
                }
            })
        );

    public ngOnInit(): void {
        this.gridSize$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap((gridSize: 1 | 2 | 4) => {
                    this.pages$$.set(paginate<Article>(this.articles, gridSize));
                    this.changePage(0);
                })
            )
            .subscribe();
    }

    public changePage(index: number, $event?: Event): void {
        $event?.preventDefault();
        $event?.stopImmediatePropagation();

        if (index < 0) index = this.pages$$().length - 1;
        if (index > this.pages$$().length - 1) index = 0;

        this.selectedIndex$$.set(index);
    }
}
